import { render, staticRenderFns } from "./newConfirm.vue?vue&type=template&id=63d3748b&scoped=true&"
import script from "./newConfirm.vue?vue&type=script&lang=js&"
export * from "./newConfirm.vue?vue&type=script&lang=js&"
import style0 from "./newConfirm.vue?vue&type=style&index=0&id=63d3748b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d3748b",
  null
  
)

export default component.exports